import Model from "@/models/Model";

export default class JournalEntryLike extends Model {
    resource() {
        return "likes";
    }

    baseURL() {
        return super.baseURL() + "/journal";
    }
}
